export const isPastDate = (dateString: string | Date) => {
  const today = new Date();
  today.setHours(0, 0, 0, 0); // Elimina la parte de la hora para comparar solo fechas
  const date = new Date(dateString);
  return date < today;
};

export const isDiscountActive = (fromDate: string, endDate: string) => {
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  const start = new Date(fromDate);
  start.setHours(0, 0, 0, 0);
  const end = new Date(endDate);
  end.setHours(23, 59, 59, 999); 

  return today >= start && today <= end;
};
